import { getEnumValues } from "sprint-common-web";

export enum OrderOutputType {
    Subtitle = 1,
    AudioVideo = 2
}

export const mapNumberToOrderOutputType = (typeNumber: number): OrderOutputType => {
    if (isNumberOrderOutputType(typeNumber)) {
        return typeNumber;
    }

    throw new Error("Incorrect OrderOutputType");
};

const isNumberOrderOutputType = (typeNumber: number) => {
    const outputTypes = getEnumValues(OrderOutputType);

    return outputTypes.some((outputType: OrderOutputType) => outputType === typeNumber);
};
